const t = Uint16Array;

export { t as default };
//# sourceMappingURL=index.js.map
